"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function normalizeHost(host) {
    var rules = [
        [/^([^\.]+)\.micro\.cian\.tech$/, undefined],
        [/^(?:[^\.]+\.)?beta\d*\.stage\.cian\.ru$/, 'python'],
        [/^[^\.]+\.([^\.]+)\.stage\.cian\.ru$/, undefined],
        [/^(?:[^\.]+\.)?[^\.]+\.dev\d*\.cian\.ru$/, 'python'],
        [/^(?:[^\.]+\.)?beta\d*\.cian\.ru$/, 'python'],
        [/^(?:[^\.]+\.)?cian\.ru$/, 'python'],
    ];
    for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
        var _a = rules_1[_i], pattern = _a[0], name_1 = _a[1];
        var matches = pattern.exec(host);
        if (matches) {
            if (name_1) {
                return name_1;
            }
            else {
                return matches[1];
            }
        }
    }
    return host;
}
exports.normalizeHost = normalizeHost;



//////////////////
// WEBPACK FOOTER
// ./src/shared/normalize_host.ts
// module id = 7
// module chunks = 0